export default __webpack_public_path__ + "static/media/Icon feather-refresh-ccw.0ae971bc.svg";